<template>
  <div class="rootDiv">
    <div class="base-info">
      <div class="title-div">
        <span>基本信息</span>
      </div>
      <div class="item-div">
        <Cell title="姓名">{{ details.birthdayInfoModel.name }}</Cell>
        <Cell title="年龄">{{ details.birthdayInfoModel.age }}</Cell>
        <Cell title="公历生日">{{ details.birthdayAnalysisModel.solarBirthday | formatDate }}</Cell>
        <Cell title="农历生日">{{ details.birthdayAnalysisModel.lunarBirthday }}</Cell>
        <Cell title="下次生日">{{ details.birthdayAnalysisModel.nextBirtday + '天' }}</Cell>
        <Cell v-if="details.birthdayInfoModel.deadDate" title="去世时间">{{
            details.birthdayInfoModel.deadDate | formatDate
          }}
        </Cell>
        <Cell v-if="details.birthdayInfoModel.deadDate" title="享年">{{ details.birthdayInfoModel.realAge }}</Cell>
        <Cell title="生肖-星座">{{
            details.birthdayAnalysisModel.zodiac + '-' + details.birthdayAnalysisModel.constellation
          }}
        </Cell>
        <Cell title="阴阳属性">{{ details.birthdayAnalysisModel.sex }}</Cell>
        <Cell title="八字">{{ details.birthdayAnalysisModel.eightWord |formatArray }}</Cell>
        <Cell title="五行">{{ details.birthdayAnalysisModel.fiveElements|formatArray }}</Cell>
        <Cell title="备注">{{ details.birthdayInfoModel.remarks }}</Cell>
      </div>
    </div>
    <div class="base-info" v-if="details.birthdayInfoModel.timeOfBirth">
      <div class="title-div">
        <span>八字分析</span>
      </div>
      <div class="item-div">
        <Cell title="五行统计">{{ details.birthdayAnalysisModel.statistics | formatWuxing }}</Cell>
        <Cell title="五行分析">
          <span v-if="details.birthdayAnalysisModel.defect">五行缺</span>
          <span style="color: red" v-if="details.birthdayAnalysisModel.defect">{{
              details.birthdayAnalysisModel.defect|formatWuxing
            }}</span>
          <span v-if="details.birthdayAnalysisModel.defect">， </span>
          <span>日主天干为</span>
          <span style="color: red">{{ details.birthdayAnalysisModel.heavenlyStem }}</span>
        </Cell>
        <Cell title="同类得分"> {{ details.birthdayAnalysisModel.similarScore| formatWuxing }}</Cell>
        <Cell title="异类得分">{{ details.birthdayAnalysisModel.heterogeneousScore| formatWuxing }}</Cell>
        <Cell title="得分差值"> {{
            details.birthdayAnalysisModel.similarScoreTotal + ' - ' + details.birthdayAnalysisModel.heterogeneousScoreTotal + ' = ' + details.birthdayAnalysisModel.total
          }}
        </Cell>
        <Cell title="旺衰分析">{{ details.birthdayAnalysisModel.total > 0 ? '八字过硬' : '八字过弱' }}</Cell>
        <Cell title="喜用神"><span style="color: red">{{ details.birthdayAnalysisModel.useGod }}</span></Cell>
      </div>
    </div>
    <div class="base-info" v-if="details.birthdayInfoModel.timeOfBirth">
      <div class="title-div">
        <span>大运</span>
      </div>
      <div class="item-div">
        <Cell v-if="details.birthdayAnalysisModel.previousSolarTerms" title="上一个节">{{
            details.birthdayAnalysisModel.previousSolarTerms.solarTermName
          }} {{ details.birthdayAnalysisModel.previousSolarTerms.date | formatDate }}
        </Cell>
        <Cell v-if="details.birthdayAnalysisModel.nextSolarTerms" title="下一个节">{{
            details.birthdayAnalysisModel.nextSolarTerms.solarTermName
          }} {{ details.birthdayAnalysisModel.nextSolarTerms.date | formatDate }}
        </Cell>
        <Cell title="起运时长">{{ details.birthdayAnalysisModel.departureLength }}</Cell>
        <Cell title="交运时间">{{ details.birthdayAnalysisModel.luckyDate |formatDate }}</Cell>
        <div class="dayun-div" style="font-size: 0.9rem;color: #2986de">
          <div style="width: 20%;float: left"><span>大运列表</span></div>
          <div style="width: 15%;float: left"><span>交运年</span></div>
          <div style="width: 15%;float: left"><span>脱运年</span></div>
          <div style="width: 12%;float: left"><span>开始</span></div>
          <div style="width: 12%;float: left"><span>结束</span></div>
          <div style="width: 12%;float: left"><span>干支</span></div>
          <div style="width: 14%;float: left"><span>转折年</span></div>
          <div style="clear: both"></div>
        </div>
        <div class="dayun-div" v-for="(value,key) in details.birthdayAnalysisModel.transportationList" :key="key">
          <div style="width: 20%;float: left"><span>{{ key }}</span></div>
          <div style="width: 15%;float: left"><span>{{ value.satrtYear }}年</span></div>
          <div style="width: 15%;float: left"><span>{{ value.endYear }}年</span></div>
          <div style="width: 12%;float: left"><span>{{ value.startAge }}岁</span></div>
          <div style="width: 12%;float: left"><span>{{ value.endAge }}岁</span></div>
          <div style="width: 12%;float: left"><span>{{ value.trunkBranch }}</span></div>
          <div style="width: 14%;float: left"><span v-if="value.ransitionYear">{{
              value.ransitionYear|formatWuxing
            }}</span></div>
          <div style="clear: both"></div>
        </div>
      </div>
    </div>
    <div class="base-info" v-if="details.birthdayInfoModel.timeOfBirth" style="margin-top: 0.4rem">
      <div class="title-div">
        <span>流年</span>
      </div>
      <div class="item-div" style="padding-left: 0.6rem;padding-right:0.6rem;">
        <div class="liunian-div" :style="{'min-width':min_width}"
             v-for="(value,key) in details.birthdayAnalysisModel.fleetingYears" :key="key">
          <div><span>{{ value }}</span></div>
          <div><span>{{ key }}</span></div>
        </div>
        <div style="clear: both"></div>
      </div>
    </div>
    <Cell title="历史上的今天" style="text-align: left;min-height: 40px" is-link
          v-on:click.native="goHistory(details.birthdayInfoModel.iD)"></Cell>
    <Cell title="生日与节日" style="text-align: left;min-height: 40px" is-link
          v-on:click.native="goHoliday()"></Cell>
    <Cell v-if="details.birthdayInfoModel.isInGroup" title="百度百科"
          style="margin-bottom: 50px;text-align: left;min-height: 40px" is-link
          v-on:click.native="goBaiDu(details.birthdayInfoModel.name)"></Cell>
  </div>
</template>

<script>
import {Cell} from 'mint-ui'
import {formatdate} from "@/js/DateUtils";

export default {
  filters: {
    formatDate(time) {
      const date = new Date(time);
      return formatdate(date, 'yyyy年MM月dd日');  // 此处可根据自己的需要自定义想要的日期格式
    },
    formatArray(array) {
      let result = '';
      array.forEach(item => {
        result += item
      })
      return result
    },
    formatWuxing(val) {
      let str = JSON.stringify(val)
      return str.replace(/{/, "").replace(/}/, "").replace(/\[/, "").replace(/]/, "").replace(/"/g, "").replace(/,/g, "，")
    },
  },
  name: "BirthdayDetails",
  components: {
    Cell
  },
  data() {
    return {
      min_width: ((document.documentElement.clientWidth - 80) / 10) + 'px',
      dayun: {
        satrtYear: null,
        endYear: null,
        startAge: null,
        endAge: null,
        trunkBranch: null,
        ransitionYear: null
      },
      details:
          {
            birthdayAnalysisModel: {
              constellation: '',
              defect: [],
              departureLength: null,
              eightWord: [],
              fiveElements: [],
              fleetingYears: null,
              heavenlyStem: null,
              heterogeneousScore: null,
              heterogeneousScoreTotal: null,
              luckyDate: null,
              lunarBirthday: null,
              nextBirtday: null,
              nextSolarTerms: {
                date: null,
                solarTerm: null,
                solarTermName: null
              },
              previousSolarTerms: {
                date: null,
                solarTerm: null,
                solarTermName: null
              },
              sex: null,
              similarScore: null,
              similarScoreTotal: null,
              solarBirthday: null,
              statistics: null,
              total: null,
              transportationList: null,
              useGod: null,
              zodiac: ''
            },
            birthdayInfoModel: {
              age: null,
              constellation: null,
              dateOfBirth: null,
              dateOfBirthDay: null,
              dateType: null,
              eightCharacters: null,
              fiveElements: null,
              fiveElementsScore: null,
              iD: null,
              isBirthday: false,
              isInGroup: false,
              isTop: true,
              name: null,
              nextDay: null,
              remarks: null,
              sex: null,
              timeOfBirth: null,
              toolTip: null,
              toolTipDetails: null,
              topTime: null,
              zodiac: null
            }
          },
      token: localStorage.getItem('token'),
      getBirthdayAnalysisUrl: '/api/business/getBirthdayAnalysis',
      getStarBirthdayAnalysisUrl: '/api/star/getStarBirthdayAnalysis',
      iscsrqnm: true,
    }
  },
  mounted() {
    if (this.$route.params.csrqnm !== undefined) {
      this.getDetails(this.$route.params.csrqnm)
      this.iscsrqnm = true
    } else if (this.$route.params.id !== undefined) {
      this.getDetails1(this.$route.params.id)
      this.iscsrqnm = false
    } else {
      this.$router.go(-1)
    }
  },
  methods: {
    goBaiDu(name) {
      window.location.href = "https://baike.baidu.com/item/" + name
    },
    goHoliday() {
      let time = this.details.birthdayInfoModel.dateOfBirthDay
      let year = time.split('-')[0]
      let month = time.split('-')[1]
      let day = time.split('-')[2]
      this.$router.push({
        name: 'm_birthday_holiday',
        params: {year: year, month: month, day: day, dateType: this.details.birthdayInfoModel.dateType}
      })
    },
    goHistory(id) {
      if (this.iscsrqnm) {
        localStorage.setItem('showCondition', '0')
        this.$router.push({name: 'm_historical_event', params: {csrqnm: id}})
      } else {
        let time = new Date(this.details.birthdayAnalysisModel.solarBirthday)
        let year = time.getFullYear()
        let month = time.getMonth() + 1
        let day = time.getDate()
        localStorage.setItem('showCondition', '0')
        this.$router.push({name: 'm_historical_event', params: {year: year, month: month, day: day}})
      }
    },
    getDetails1(id) {
      let that = this
      this.$ajax({
        method: 'get',
        url: this.getStarBirthdayAnalysisUrl,
        params: {id: id},
        headers: {token: this.token}
      }).then((response) => {
        if (response.data.result) {
          that.details = response.data['responseData']
        } else {
          that.$messagebox.alert(response.data.message)
        }
      }).catch(response => {
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    getDetails(csrqnm) {
      let that = this
      this.$ajax({
        method: 'get',
        url: this.getBirthdayAnalysisUrl,
        params: {csrqnm: csrqnm},
        headers: {token: this.token}
      }).then((response) => {
        if (response.data.result) {
          that.details = response.data['responseData']
        } else {
          that.$messagebox.alert(response.data.message)
        }
      }).catch(response => {
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
  }
}
</script>

<style lang="less" scoped>
.rootDiv {
  margin: -0.5rem;
}

.base-info {
  .title-div {
    background-color: #8450C5;
    padding-top: 5px;
    padding-bottom: 5px;

    span {
      font-size: 1.4rem;
      color: white;
    }
  }

  .item-div {
    text-align: left;
  }
}

/deep/ .mint-cell {
  min-height: 30px
}

/deep/ .mint-cell-text {
  color: green;
}

.dayun-div {
  padding: 3px;
  margin-left: 0.6rem;
  margin-right: 0.6rem;
  font-size: 0.7rem;
  background-color: #b6d8af;
  border-bottom: gray 0.5px solid;
}

.liunian-div {
  padding: 3px;
  font-size: 0.7rem;
  background-color: #b6d8af;
  border-bottom: gray 0.5px solid;
  float: left;
}
</style>
